import { Directive, ElementRef, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserContext } from '../../../services/context/user.context.service';
import { COUNTRY } from '../../../types/enums';

/**
 * @deprecated Use Country Service instead
 */
@Directive({
  selector: '[appCountry]',
})
export class CountryDirective implements OnInit {
  @Input('appCountry') allowedCountries: COUNTRY[] = [];

  constructor(
    private readonly _usrCtxSvc: UserContext,
    private readonly _templateRef: TemplateRef<any>,
    private readonly _viewContainer: ViewContainerRef
  ) {}

  ngOnInit(): void {
    const show = this._usrCtxSvc.userHasAccessToCountries(this.allowedCountries);
    if (show) {
      this._viewContainer.clear();
      this._viewContainer.createEmbeddedView(this._templateRef);
    } else {
      this._viewContainer.clear();
    }
  }
}
